import React from 'react';
import PropTypes from 'prop-types';
import { emptyObject } from 'ui-components/default-props/empty';

const Context = React.createContext();
const { Consumer, Provider } = Context;

const ModalPortalContextProvider = ({ children, hotkeyValue = emptyObject }) => {
  return (
    <Provider value={hotkeyValue}>
      <React.Fragment>{children}</React.Fragment>
    </Provider>
  );
};

ModalPortalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  hotkeyValue: PropTypes.object,
};

export { Consumer, Context, ModalPortalContextProvider as Provider };
